import { CommissionInvoice } from '../../../types/models/commission/commission.types';
import { COMMERCIAL_ENDPOINTS } from '../../../utils/api/endpoints/commercialEndpoints';

const PREFIX = '[queryAllBoostsInvoices]';

export const queryAllBoostsInvoices = async () => {
  console.log(PREFIX, `Fetching boosts invoices...`);
  const response = await COMMERCIAL_ENDPOINTS.getAllBoostsInvoices();

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received boosts invoices.`);
  return json as CommissionInvoice[];
};
